export default "__VITE_ASSET__cbIbNWDI__"